import { Routes } from '@angular/router';
import { ProposalsPage } from './proposals-page/proposals-page.component';
import { ActivePage } from './active-page/active-page.component';
import { InvitationsPage } from './invitations-page/invitations-page.component';
import { ProposalDetails } from './proposal-details/proposal-details.component';
import { CreateAccountComponent } from './create-account/create-account.component';
import { CreateAccountThanksComponent } from './create-account-thanks/create-account-thanks.component';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { AuthGuard } from './helpers/auth.guard';
import { RoleGuard } from './helpers/role.guard';
import { setupLockGuard } from './helpers/setup-lock.guard';
import { ManageAccountComponent } from './manage-account/manage-account.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { SettingsComponent } from './settings/settings.component';
import { ProjectHistoryPageComponent } from './project-history/project-history-page/project-history-page.component';
import { ProjectOverviewPageComponent } from './project-overview/project-overview-page/project-overview-page.component';
import { InternalComponent } from './internal/internal.component';
import { InternalDashboardComponent } from './internal/internal-dashboard/internal-dashboard.component';
import { AuditTimelineComponent } from './internal/audit-timeline/audit-timeline.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  // --- Professional Associate routes (PA only) ---
  {
    path: 'invitations',
    component: InvitationsPage,
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
    data: { requiredRole: 'PROFESSIONAL_ASSOCIATE' },
  },
  {
    path: 'proposals',
    component: ProposalsPage,
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
    data: { requiredRole: 'PROFESSIONAL_ASSOCIATE' },
  },
  {
    path: 'proposals/:id',
    component: ProposalDetails,
    data: { type: 'proposal', requiredRole: 'PROFESSIONAL_ASSOCIATE' },
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
  },
  {
    path: 'invitations/:id',
    component: ProposalDetails,
    data: { type: 'invitation', requiredRole: 'PROFESSIONAL_ASSOCIATE' },
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
  },
  {
    path: 'active/:id',
    component: ProposalDetails,
    data: { type: 'active', requiredRole: 'PROFESSIONAL_ASSOCIATE' },
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
  },
  {
    path: 'active',
    component: ActivePage,
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
    data: { requiredRole: 'PROFESSIONAL_ASSOCIATE' },
  },
  {
    path: 'project-overview/:id',
    component: ProjectOverviewPageComponent,
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
    data: { requiredRole: 'PROFESSIONAL_ASSOCIATE' },
  },
  {
    path: 'project-overview-proposal/:id',
    component: ProposalDetails,
    data: { type: 'project-overview', requiredRole: 'PROFESSIONAL_ASSOCIATE' },
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
  },
  {
    path: 'project-history',
    component: ProjectHistoryPageComponent,
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
    data: { requiredRole: 'PROFESSIONAL_ASSOCIATE' },
  },
  {
    path: 'project-history/:id',
    component: ProposalDetails,
    data: { type: 'project-history', requiredRole: 'PROFESSIONAL_ASSOCIATE' },
    canActivate: [AuthGuard, RoleGuard, setupLockGuard],
  },

  // --- Internal routes ---
  {
    path: 'internal',
    component: InternalComponent,
    canActivate: [AuthGuard, RoleGuard],
    data: { requiredRole: 'INTERNAL' },
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        // Guard the child route explicitly — the parent canActivate does not re-run on
        // subsequent child navigations once the parent is already active (matches the audit child).
        path: 'dashboard',
        component: InternalDashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { requiredRole: 'INTERNAL' },
      },
      {
        // FIX 5: guard the child route explicitly — the parent canActivate does not
        // re-run on subsequent child navigations once the parent is already active.
        path: 'audit/:entityType/:entityId',
        component: AuditTimelineComponent,
        canActivate: [AuthGuard, RoleGuard],
        data: { requiredRole: 'INTERNAL' },
      },
    ],
  },

  // --- Public routes ---
  { path: 'createaccount', component: CreateAccountComponent },
  { path: 'thanks', component: CreateAccountThanksComponent },
  { path: 'login', component: LoginComponent },
  { path: 'forgotpassword', component: ForgotPasswordComponent },
  // Opened from an emailed reset or invite link; main.ts has already taken the
  // token out of the fragment.
  { path: 'set-password', component: SetPasswordComponent },

  // --- Authenticated routes (any role) ---
  {
    path: 'manageaccount',
    component: ManageAccountComponent,
    canActivate: [AuthGuard, setupLockGuard],
  },
  {
    path: 'contact',
    component: ContactUsComponent,
    canActivate: [AuthGuard, setupLockGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard, setupLockGuard],
  },
];
